<template>
    <cms-block v-bind="$props" @block-selected="selectBlock" no-padding>
        <cms-block-table-cell v-for="(child, index) in block.children" :key="child.id" @block-selected="selectBlock" :block="child" :block-selection="blockSelection"
                            :parent="block" :editable="editable" :column="parent.columns[index]"/>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsBlockTableCell from "@components/editor/rendering/blocks/cms-block-table-cell.vue";

export default {
    name: `cms-block-table-row`,
    components: {
        CmsBlockTableCell,
        CmsBlock
    },
    extends: CmsBlock
}
</script>

<style lang="scss" scoped>
</style>
